import api from '@/api'

export default {
    getCurrentUser(): Promise<account.TCurrent> {
        return api.get<account.TCurrent>({url: '/common/auth/api/current'})
    },

    getPhotoUrl(address: string): Promise<string> {
        return api.get({
            url: `/Hr/Photo/api/get?email=${address}`
        })
    },

    getPhotoUrlByCodes(codes: string[]): Promise<any[]> {
        return api.post({
            url: '/Hr/Photo/api/byCodes',
            data: codes
        });
    },

    changeInitPassword(email: string, password: string, newPassword: string): Promise<boolean | string> {
        return api.post({
            url: '/yek/cboaccount/api/password',
            data: {
                username: email,
                password: password,
                newPassword: newPassword
            }
        })
    }

    // getUser(email: string): Promise<account.User> {
    //     return api.get({
    //         url: `/api/hr/person`,
    //         params: {
    //             email,
    //         },
    //     });
    // },

    // getUserByPersonCode(personCode: string): Promise<account.User> {
    //     return api.get({
    //         url: `/api/hr/department/person`,
    //         params: {
    //             personCode,
    //         }
    //     })
    // }
}
